import { Component, computed, inject, input, Signal } from '@angular/core'
import { CartService } from '@src/app/core/services/cart.service.js'
import { NavService } from '@src/app/core/services/nav.service.js'
import { SignalStore } from '@src/app/core/store/signalStore.js'
import { flowUtils } from '@src/app/core/util/flow.util.js'
import { ActivatePage, AnyPage, Page } from '@src/app/shared/typings/enum/pages.js'

type FlowMember = AnyPage | AnyPage[]

const FLOW_ACTIVATE: FlowMember[] = [ActivatePage.credentials, ActivatePage.orderSummary]

@Component({
  selector: 'app-progress-indicator',
  templateUrl: './progress-indicator.component.html',
  styleUrls: ['./progress-indicator.component.scss'],
  standalone: false,
})
export class ProgressIndicatorComponent {
  store = inject(SignalStore)
  private cartService = inject(CartService)
  private navService = inject(NavService)

  FLOW_DEFAULT = computed(() => {
    const { country } = this.store.$userLocale()
    const pages: (Page | Page[])[] = [Page.measuringDevice]
    if (country === 'US') {
      pages.push([
        Page.coveredByInsurance,
        Page.chooseProvider,
        Page.providerInfo,
        Page.clarifyProvider,
      ])
    }
    pages.push(Page.plans, Page.credentials, Page.address, Page.payment)
    return pages
  })

  FLOW_OURA = computed(() => {
    return [
      Page.measuringDevice,
      Page.goal,
      Page.plans,
      Page.credentials,
      Page.address,
      Page.payment,
    ]
  })

  protected page = input.required<AnyPage>()

  step = computed(() => this.getStep(this.page()))
  flow: Signal<FlowMember[]> = computed(() => this.getFlow())

  public Page = Page

  getStep(page: AnyPage): number {
    const flow = this.flow()
    let index = flow.indexOf(page)
    if (index === -1) {
      index = flow.findIndex(p => Array.isArray(p) && p.includes(page))
    }
    return index + 1
  }

  getFlow(): FlowMember[] {
    const state = this.store.getState()
    const { cart } = state

    const isOuraFlow = flowUtils.isOuraFlow({
      state,
      params: this.navService.getQueryParams(),
    })

    const isActivateFlow = this.cartService.hasActivationCodeApplied(cart)

    if (isActivateFlow) {
      return FLOW_ACTIVATE
    }

    let flow: FlowMember[] = this.FLOW_DEFAULT()
    if (this.page() === Page.oura || isOuraFlow) {
      flow = this.FLOW_OURA()
    }

    return flow
  }
}
